import cloneDeep from "lodash/cloneDeep";
import globalData from "../globalData";

const uuidv4 = () => {
  const pattern = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx";
  return pattern.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16).toUpperCase();
  });
}

const formatQuery = (option: any) => {
  const method = String(option.method || "").toLowerCase();
  const cloneOption = cloneDeep(option)
  if (method === "get") {
    const { data = {} } = cloneOption
    if (typeof data === "object" && !Array.isArray(data)) {
      Object.keys(data).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(data, key) && (data[key] === undefined || data[key] === null)) {
          data[key] = "";
        }
      });
    }
    return cloneOption;
  }
  if (!cloneOption.data || JSON.stringify(cloneOption.data) === "{}") {
    cloneOption.data = {
      _ver: globalData.getVersion()
    }
  }
  if (method === "delete") {
    cloneOption.data = ""
  }
  return cloneOption
}

export {
  uuidv4,
  formatQuery,
};
